const CONSTRUCTOR_FIELDS_GROUP_MAP = {
  // dealer
  DEALER_GET_CITIES: "dealer/getCities",
  // vehicle
  VEHICLE_GET_VEHICLES: "vehicle/getVehicles",
  // vehicleEquipment
  VEHICLE_EQUIPMENT_GET_SPECIFICATIONS: "vehicleEquipment/getSpecifications",
  VEHICLE_EQUIPMENT_GET_SPECIFICATION_GROUPS: "vehicleEquipment/getSpecificationGroups",
  VEHICLE_EQUIPMENT_GET_OPTION_GROUPS: "vehicleEquipment/getOptionGroups"
};
const CONSTRUCTOR_REFERENCE_FIELDS_GROUP_MAP = {
  // dealer
  DEALER_GET_DEALERSHIP: "dealer/getDealership",
  DEALER_GET_CITY: "dealer/getCity",
  // vehicle
  VEHICLE_GET_VEHICLES: "vehicle/getVehicles",
  VEHICLE_GET_VEHICLE: "vehicle/getVehicle",
  // vehicleEquipment
  VEHICLE_EQUIPMENT_GET_SPECIFICATIONS: "vehicleEquipment/getSpecifications",
  VEHICLE_EQUIPMENT_GET_SPECIFICATION_GROUPS: "vehicleEquipment/getSpecificationGroups",
  VEHICLE_EQUIPMENT_GET_OPTION_GROUPS: "vehicleEquipment/getOptionGroups"
};
const FIELDS_GROUP_MAP = {
  ...CONSTRUCTOR_FIELDS_GROUP_MAP,
  ...CONSTRUCTOR_REFERENCE_FIELDS_GROUP_MAP
};
export {
  CONSTRUCTOR_FIELDS_GROUP_MAP,
  CONSTRUCTOR_REFERENCE_FIELDS_GROUP_MAP,
  FIELDS_GROUP_MAP
};
